import TextFieldDate from '../../UI/TextFieldDate'
import TextField from '../../UI/TextField'
import Button from '../../UI/Button';
import { Grid, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';

const useStyles = makeStyles({

    container: {
        padding: '10px',
    },
    closeIcon: {
        cursor: 'pointer',
    },
});

const DiaLetivoExtraForm = ({
    diaLetivoExtra,
    setDiaLetivoExtra,
    onSubmit,
    onRemove,
    isLoadingAction
}) => {
    const classes = useStyles();

    const handleDateChange = (date) => {
        setDiaLetivoExtra({
            ...diaLetivoExtra,
            data: dayjs(date)
        })
    }

    const handleChange = (event) => {
        setDiaLetivoExtra({
            ...diaLetivoExtra,
            [event.target.name]: event.target.value
        })
    }

    return (
        <Grid
            container
            component={Paper}
            spacing={2}
            className={classes.container}
            justifyContent='center'
        >
            <Grid size={12}>
                <CloseIcon
                    onClick={() => setDiaLetivoExtra(null)}
                    className={classes.closeIcon}
                    fontSize='small'
                />
                <form onSubmit={onSubmit}>
                    {console.log(diaLetivoExtra.data)}
                    <TextFieldDate
                        value={diaLetivoExtra.data ? diaLetivoExtra.data : null}
                        onChange={handleDateChange}
                        label='Data'
                    />
                    <TextField
                        value={diaLetivoExtra.descricao}
                        onChange={handleChange}
                        name='descricao'
                        label='Descrição'
                    />
                    <Grid container spacing={2}>
                        <Grid size={3}>
                            <Button
                                type='submit'
                                disabled={isLoadingAction}
                            >
                                Salvar
                            </Button>
                        </Grid>
                        <Grid size={3}>
                            <Button
                                onClick={onRemove}
                                disabled={isLoadingAction}
                            >
                                Remover
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Grid>
        </Grid>
    );
}

export default DiaLetivoExtraForm;